export class UniLicenseComponent {
    constructor() {
        this.uiDevKit = undefined;
        this.materialDesignKit = undefined;
        this.proComponentsKit = undefined;
    }
    connectedCallback() {
        this.el.hidden = true;
        if (this.uiDevKit) {
            localStorage.setItem('uni.license.udk', this.uiDevKit);
        }
        if (this.materialDesignKit) {
            localStorage.setItem('uni.license.mat', this.materialDesignKit);
        }
        if (this.proComponentsKit) {
            localStorage.setItem('uni.license.pro', this.proComponentsKit);
        }
    }
    static get is() { return "uni-license"; }
    static get properties() {
        return {
            "uiDevKit": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "ui-dev-kit",
                "reflect": true
            },
            "materialDesignKit": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "material-design-kit",
                "reflect": true
            },
            "proComponentsKit": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "pro-components-kit",
                "reflect": true
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=license.component.js.map
